// Generated by Melange

import * as React from "react";

const defaultOrg = {
  id: 0,
  country: /* COUNTRY_KAZ */ 1,
  "type'": /* ORG_TYPE_UNSPECIFIED */ 0,
  name: "",
  tin: ""
};

const defaultOperator = {
  id: 0,
  country: /* COUNTRY_KAZ */ 1,
  name: ""
};

const empty = {
  ctx: /* IdentityCtx */ 0,
  org: defaultOrg,
  operator: defaultOperator
};

function initValue_1(param) {
  
}

const initValue = [
  empty,
  initValue_1
];

const context = React.createContext(initValue);

const make = context.Provider;

function makeProps(value, children, param) {
  return {
    value: value,
    children: children
  };
}

const ContextProvider = {
  make: make,
  makeProps: makeProps
};

function useTenant(param) {
  return React.useContext(context);
}

function getInitialCtx(ctx) {
  if (ctx === "operator") {
    return /* AdminCtx */ 1;
  } else {
    return /* IdentityCtx */ 0;
  }
}

function createTenantContext(initialCtx) {
  const match = React.useReducer((function (state, action) {
    if (/* tag */ typeof action === "number" || typeof action === "string") {
      return {
        ctx: /* IdentityCtx */ 0,
        org: defaultOrg,
        operator: defaultOperator
      };
    }
    switch (action.TAG) {
      case /* OrgChanged */ 0 :
        return {
          ctx: /* IdentityCtx */ 0,
          org: action._0,
          operator: defaultOperator
        };
      case /* OperatorReset */ 1 :
        if (state.org.id !== 0 || state.operator.id === 0) {
          return {
            ctx: /* AdminCtx */ 1,
            org: defaultOrg,
            operator: action._0
          };
        } else {
          return state;
        }
      case /* OperatorChanged */ 2 :
        const operator = action._0;
        if (state.operator.id !== operator.id) {
          return {
            ctx: /* AdminCtx */ 1,
            org: defaultOrg,
            operator: operator
          };
        } else {
          return state;
        }
      case /* OperatorOrgChanged */ 3 :
        const org = action._1;
        if (state.org.id !== org.id) {
          return {
            ctx: /* AdminCtx */ 1,
            org: org,
            operator: action._0
          };
        } else {
          return state;
        }
    }
  }), {
    ctx: initialCtx,
    org: defaultOrg,
    operator: defaultOperator
  });
  return [
    match[0],
    match[1]
  ];
}

export {
  ContextProvider,
  useTenant,
  getInitialCtx,
  createTenantContext,
}
/* context Not a pure module */
